module.exports = __webpack_public_path__ + "static/media/bell.a2aea5e1.mp3";